import { c as _c } from "react/compiler-runtime";
import { ResponsiveImage } from '@/app/components/media/app-image';
import type { SizesString } from '@/app/components/media/app-image/shared/image-size-types';
import type { SpartanProductFeatureMediaImageProps, SpartanProductFeatureMediaImageVariant } from '@/app/lcv/components/sections/spartan/products/shared/feature-carousel/feature-media/types';
import { getSpartanProductFeatureDesktopImageSource, getSpartanProductFeatureMobileImageSource, SPARTAN_PRODUCT_FEATURE_CAROUSEL_IMAGE_CLASS_NAME, SPARTAN_PRODUCT_FEATURE_CAROUSEL_MAIN_SIZES, SPARTAN_PRODUCT_FEATURE_CAROUSEL_THUMBNAIL_SIZES } from '@/app/lcv/components/sections/spartan/products/shared/feature-carousel/media';
import { cn } from '@/app/utils/cn';
const VARIANT_CONFIG = {
  main: {
    sizes: SPARTAN_PRODUCT_FEATURE_CAROUSEL_MAIN_SIZES,
    width: 1280,
    height: 720,
    className: SPARTAN_PRODUCT_FEATURE_CAROUSEL_IMAGE_CLASS_NAME,
    imgClassName: undefined
  },
  thumbnail: {
    sizes: SPARTAN_PRODUCT_FEATURE_CAROUSEL_THUMBNAIL_SIZES,
    width: 320,
    height: 180,
    className: 'relative aspect-1-1 md:aspect-16-9 w-full overflow-hidden rounded-sm',
    imgClassName: 'rounded-sm'
  }
} as const satisfies Record<SpartanProductFeatureMediaImageVariant, {
  sizes: SizesString;
  width: number;
  height: number;
  className: string;
  imgClassName?: string;
}>;
export const SpartanProductFeatureMediaImage = t0 => {
  const $ = _c(27);
  const {
    image,
    alt,
    testId,
    variant: t1,
    className,
    imgClassName,
    imgRef,
    fade,
    loading,
    fetchPriority,
    onLoad,
    onError
  } = t0;
  const variant = t1 === undefined ? "main" : t1;
  const config = VARIANT_CONFIG[variant];
  let t2;
  if ($[0] !== config.sizes || $[1] !== image) {
    t2 = getSpartanProductFeatureMobileImageSource(image, config.sizes);
    $[0] = config.sizes;
    $[1] = image;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== config.sizes || $[4] !== image) {
    t3 = getSpartanProductFeatureDesktopImageSource(image, config.sizes);
    $[3] = config.sizes;
    $[4] = image;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = config.width;
  const t5 = config.height;
  let t6;
  if ($[6] !== className || $[7] !== config.className) {
    t6 = cn(config.className, className);
    $[6] = className;
    $[7] = config.className;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== config.imgClassName || $[10] !== imgClassName) {
    t7 = cn(config.imgClassName, imgClassName);
    $[9] = config.imgClassName;
    $[10] = imgClassName;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== alt || $[13] !== config.height || $[14] !== config.width || $[15] !== fade || $[16] !== fetchPriority || $[17] !== imgRef || $[18] !== loading || $[19] !== onError || $[20] !== onLoad || $[21] !== t2 || $[22] !== t3 || $[23] !== t6 || $[24] !== t7 || $[25] !== testId) {
    t8 = <ResponsiveImage mobileSrc={t2} desktopSrc={t3} alt={alt} width={t4} height={t5} objectFit="cover" className={t6} imgClassName={t7} imgRef={imgRef} fade={fade} loading={loading} fetchPriority={fetchPriority} onLoad={onLoad} onError={onError} testId={testId} />;
    $[12] = alt;
    $[13] = config.height;
    $[14] = config.width;
    $[15] = fade;
    $[16] = fetchPriority;
    $[17] = imgRef;
    $[18] = loading;
    $[19] = onError;
    $[20] = onLoad;
    $[21] = t2;
    $[22] = t3;
    $[23] = t6;
    $[24] = t7;
    $[25] = testId;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
};